/** Firebase UID for RAG voice APIs — same as mobile (user.uid first). */
export function resolveVoiceBusinessId(currentBusiness, user) {
  return (
    user?.uid ||
    currentBusiness?.business_id ||
    currentBusiness?.id ||
    ''
  );
}
